import 'react';
import 'antd';
import '../AntdCountryPhoneInput/config.js';
import '../AntdCountryPhoneInput/phone-input-styles.js';
import styled from 'styled-components';
import '@yaotai/common-utils';

styled.div `
  ${props => props.isMobile &&
    `
    .ant-select-arrow {
      margin-top: 0;
    }
  `}
`;
